//  Table scroll

var TableScroll = {

	selector: '[data-table-scroll]',
	tableRow: '[data-table-row]',
	tableCol: '[data-table-col]',

	init: function () {
		if (!$(this.selector).length) return;
		this.setTheadPosition();
		this.bindScrollEvent();
	},

	setTheadPosition: function () {

		$(TableScroll.selector).each(function (i) {

			// get initial dimentions from relative position
			var $thisTable = $(this),
				thisRow = $thisTable.find(TableScroll.tableRow),
				thisCol = $thisTable.find(TableScroll.tableCol),
				thisTdHead = thisRow.find('.table-header'),
				thisTh = thisRow.find('tr th'),
				thisTbody = $thisTable.find('tbody'),
				thisTd = thisTbody.find('tr td'),
				tHeadRowHeight = thisRow.outerHeight(),
				colHeadWidth = thisCol.width();

			// set dimentions for header cells
			if (thisRow.length) {

				thisTd.each(function () {
					var cellTd = $(this),
						cellWidth = cellTd.outerWidth();

					cellTd.css('min-width', cellWidth + 'px');
					cellTd.attr('width', cellWidth + 'px');

				});

				thisTdHead.each(function () {
					var cellTdHead = $(this),
						tdHeadWidth = cellTdHead.outerWidth();

					cellTdHead.css('min-width', tdHeadWidth + 'px');
					cellTdHead.attr('width', tdHeadWidth + 'px');
				});

				thisTh.each(function () {
					var cellTh = $(this),
						cellThWidth = cellTh.outerWidth();

					cellTh.css('min-width', cellThWidth + 'px');
					cellTh.attr('width', cellThWidth + 'px');
				});


				// set Tbody position
				thisRow.css('height', tHeadRowHeight + 'px');
				thisTbody.css('margin-top', tHeadRowHeight);

				TableScroll.addStickyClass(thisRow, thisTbody);

			}

			// set dimention and position for header col
			if (thisCol.length) {
				thisCol.css('top', tHeadRowHeight);
				thisTbody.css('left', colHeadWidth);
				TableScroll.addStickyClass(thisCol, thisTbody);
			}
		});
	},

	addStickyClass: function (thisRow, thisTbody) {

		thisRow.addClass('is-sticky');
		thisTbody.addClass('has-sticky');

	},

	bindScrollEvent: function () {

		$(TableScroll.selector).on('scroll', function () {

			var $thisTable = $(this),
				thisRow = $thisTable.find(TableScroll.tableRow),
				thisCol = $thisTable.find(TableScroll.tableCol),
				scrollLeftValue = $(this).scrollLeft() + "px",
				scrollTopValue = $(this).scrollTop() + "px";

			if (thisRow.length) {
				// move tHead row top position
				thisRow.css('transform', 'translate(0,' + scrollTopValue + ')');
			}
			if (thisCol.length) {
				// move tHead col left position
				thisCol.css('transform', 'translate(' + scrollLeftValue + ', 0)');
			}

		});
	}

};


$(document).ready(function () {
	TableScroll.init();
});